import { render, staticRenderFns } from "./ListaLocaisUnidade.vue?vue&type=template&id=02c8fc89&scoped=true"
import script from "./ListaLocaisUnidade.vue?vue&type=script&lang=js"
export * from "./ListaLocaisUnidade.vue?vue&type=script&lang=js"
import style0 from "./ListaLocaisUnidade.vue?vue&type=style&index=0&id=02c8fc89&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02c8fc89",
  null
  
)

export default component.exports